const id_master_unit = {
    add: "tambah satuan",
    code: "kode satuan",
    name: "nama satuan",

    error: {
        code: "Kode satuan tidak boleh kosong.",
        name: "Nama satuan tidak boleh kosong.",
        create: "Gagal membuat satuan.",
        delete: "Gagal menghapus satuan.",
        edit: "Gagal mengubah satuan.",
    },

    success: {
        create: "Berhasil membuat satuan.",
        delete: "Berhasil menghapus satuan.",
        edit: "Berhasil mengubah satuan.",
    }

}

export default id_master_unit;